import { all, call, put, takeEvery } from '@redux-saga/core/effects';
import _ from 'lodash';
import ILoanEmail from '~Api/LoanEmail/ILoanEmail';
import { parseLoanEmail } from '~Api/LoanEmail/parsers';
import {
    loanEmailTextRequest,
    loanEmailsListRequest,
} from '~Api/LoanEmail/requests';
import { IFetchResponse } from '~utilities/fetch';
import {
    ILoanEmailTextGetAction,
    ILoanEmailsListAction,
    loanEmailTextSetAction,
    loanEmailsSetAction,
} from './actions';
import LoanEmailsActionsEnum from './ActionsEnum';

function* loanEmailsList(action: ILoanEmailsListAction): Iterator<unknown> {
    const response: IFetchResponse = yield call(loanEmailsListRequest, action.loanUuid, action.pageNumber, action.perPage);
    const count: number = parseInt(response.headers.get('X-Pagination-Total-Records'), 10);
    const emails: ILoanEmail[] = _.map(response.body, parseLoanEmail);

    yield put(loanEmailsSetAction(action.loanUuid, emails, count));
}

function* loanEmailTextGet(action: ILoanEmailTextGetAction): Iterator<unknown> {
    const response: IFetchResponse = yield call(loanEmailTextRequest, action.loanEmailUuid);

    yield put(loanEmailTextSetAction(action.loanEmailUuid, response.body.text));
}

export function* LoanEmailsSagas(): Iterator<unknown> {
    yield all([
        takeEvery(LoanEmailsActionsEnum.LoanEmailsList, loanEmailsList),
        takeEvery(LoanEmailsActionsEnum.LoanEmailTextGet, loanEmailTextGet),
    ]);
}
